import { getConfig } from '../../shared/env/envManager';
import { useAuthTokenStore } from '../../shared/store/authStore';
import type { AnalyticsEvent } from '../domain/analyticsEvent';

const ANALYTICS_ENDPOINT = '/api/v1/analytics/events';

export const sendAnalyticsEvent = async (
  event: AnalyticsEvent,
): Promise<void> => {
  const baseUrl = getConfig().apiBaseUrl.replace(/\/+$/, '');
  const authToken = useAuthTokenStore.getState().authToken;
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (authToken) {
    headers.Authorization = authToken;
  }

  const response = await fetch(`${baseUrl}${ANALYTICS_ENDPOINT}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(event),
    credentials: 'omit',
    keepalive: true,
  });

  if (!response.ok) {
    throw new Error(`Analytics request failed with status ${response.status}`);
  }
};
